import axiosConfig from "./axiosConfig";

const deleteHealthEvent = async (
  authToken: string,
  siteId: string,
  eventId: number
): Promise<void> => {
  await axiosConfig.delete(`/site/${siteId}/health/events/${eventId}`, {
    headers: { Authorization: `Bearer ${authToken}` },
  });
};

export default deleteHealthEvent;
